<div class="error-handler" style="background-color:crimson; color: white;">
    <div class="error-handler-line">
        <h3 style="color: white;">{{ error.name }}</h3>
        <p>{{ error.message }}</p>
    </div>
</div>